type RefreshCallback = () => void;

export interface RefreshRunner {
  clearLatest: (callback: RefreshCallback) => void;
  finish: () => void;
  setLatest: (callback: RefreshCallback) => void;
  start: (callback: RefreshCallback) => boolean;
}

export function createRefreshRunner(): RefreshRunner {
  let activeRefresh: RefreshCallback | null = null;
  let queued = false;
  let latestRefresh: RefreshCallback | null = null;

  return {
    clearLatest(callback) {
      if (latestRefresh !== callback) {
        return;
      }

      latestRefresh = null;
      queued = false;
    },
    finish() {
      activeRefresh = null;
      if (!queued) {
        return;
      }

      queued = false;
      latestRefresh?.();
    },
    setLatest(callback) {
      latestRefresh = callback;
    },
    start(callback) {
      if (activeRefresh) {
        // Replay only a replacement effect (StrictMode), never duplicate focus work.
        queued ||= callback !== activeRefresh;
        return false;
      }

      activeRefresh = callback;
      return true;
    },
  };
}
